import React, {useState} from "react";
import UniversityList from "../components/UniversityList";
import UniversityModal from "../components/UniversityModal";
import {useNavigate} from "react-router-dom";
import ReportList from "../components/ReportList";
import ReportModal from "../components/ReportModal";
import AdminNav from "../components/AdminNav";
import Sidebar from "../components/Sidebar";

const ReportsManagement = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const navigate = useNavigate(); // For navigation
    const role = localStorage.getItem("role"); // Fetch user role
    const handleSave = () => {
        console.log("Closing modal...");
        setShowModal(false);
        setSelectedReport(null);
    };
    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        localStorage.clear(); // Clear all stored session data
        navigate("/login");
    };
    const handleEdit = (report) => {
        console.log("Editing report:", report);
        setSelectedReport(report);
        setShowModal(true);
    };

    return (
        <div className="dashboard">
            <Sidebar/>
            <main className="main-content">
                <div>
                    <header className="header component">
                        <span className="component-header">Manage Analytics</span>
                        <button
                            className="btn btn-primary action"
                            onClick={() => {
                                setSelectedReport(null);
                                setShowModal(true);
                            }}
                        >
                             <i className="fa fa-plus"></i>  Add Dashboard
                        </button>
                    </header>
                    <hr/>
                    <ReportList onEdit={handleEdit}/>
                    {showModal && (
                        <ReportModal
                            report={selectedReport}
                            onClose={() => setShowModal(false)}
                            onSave={handleSave}
                        />
                    )}
                </div>
            </main>
        </div>
    );
};

export default ReportsManagement;